import { createClickRewardApiStore } from '@/api'

const getInitialPageParams = () => ({
  pageNumber: 1,
  pageCount: 15,
})

const apiStore = createClickRewardApiStore([
  {
    action: '_requestList',
    path: `partners/{partnerNo}/requests`,
    pathParams: ['partnerNo'],
    method: 'get',
    cacheable: false,
  },
])

function applyPartnerNo(params = {}, rootGetters = {}) {
  return {
    ...params,
    partnerNo: rootGetters['authentication/partnerNo'],
  }
}

export default {
  namespaced: true,

  mixins: [apiStore],

  state: {
    pageParams: getInitialPageParams(),

    searchParams: {},

    searchResult: {
      list: [],
      total: 0,
    },
  },

  actions: {
    async getRequestList({ dispatch, getters, commit, rootGetters }) {
      const response = await dispatch('_requestList', {
        params: applyPartnerNo(getters.currentParams, rootGetters),
      })

      commit('SET_SEARCH_RESULT', response.data)
    },
  },

  mutations: {
    SET_SEARCH_PARAMS(state, newSearchParams) {
      state.searchParams = newSearchParams
    },

    SET_PAGE_PARAMS(state, newPageParams) {
      state.pageParams = {
        ...state.pageParams,
        ...newPageParams,
      }
    },

    RESET_PAGE_PARAMS(state) {
      state.pageParams = getInitialPageParams()
    },

    SET_SEARCH_RESULT(state, data) {
      state.searchResult = {
        list: data.metrics,
        total: data.info.total,
      }
    },

    SET_TOTAL(state, total = 0) {
      state.total = total
    },
  },

  getters: {
    requestList(state) {
      return state.searchResult.list
    },

    currentParams(state) {
      return {
        ...state.searchParams,
        ...state.pageParams,
      }
    },
  },
}
